import {Comment} from "./Comment";
import {Action, ToggleName} from "../State";
import {Dispatch} from "react";
import {Record} from "./Record";
import {Fetcher} from "./Fetcher";

export class Factory<T> {
    constructor(private type: new () => T) { }

    getNew(): T {
        return new this.type();
    }
}

export class Paginator<RecordType extends Record> {
    records:RecordType[];
    recordCount: number | null;
    pluralName:string;
    callback:((record:RecordType[]) => void) | null;
    errorHandler:((err:any) => void) | null;
    nextPageToken: string;
    onChange: (() => void) | null = null;
    fetcher: Fetcher;

    constructor(private recordType: new () => RecordType,
                records:RecordType[], recordCount: number | null,
                path:string, pluralName:string, nextPageToken: string,
                callback:((records:RecordType[]) => void) | null, errorHandler:((err:any) => void) | null) {
        this.records = records;
        this.recordCount = recordCount;
        this.pluralName = pluralName;
        this.nextPageToken = nextPageToken;
        this.callback = callback;
        this.errorHandler = errorHandler;
        this.fetcher = new Fetcher(path);
        this.fetcher.onChange = () => { this.changed(); };
    }

    isInProgress(): boolean { return this.fetcher.isInProgress() }

    hasErrors(): boolean { return this.fetcher.hasErrors() }

    errors(): string[] { return this.fetcher.errors() }

    changed(): void {
        if(this.onChange) {
            this.onChange();
        }
    }

    hasMoreRecords(): boolean {
        return !!this.nextPageToken && (!this.recordCount || this.records.length < this.recordCount);
    }

    newInstance() : RecordType {
        return new this.recordType();
    }

    prepend(records:RecordType[]) {
        this.records.unshift(...records);
    }

    append(records:RecordType[]) {
        this.records.push(...records);
    }

    more(): void {
        this.fetcher.get({ next_page_token: this.nextPageToken }, (json) => {
            let records:RecordType[] = json[this.pluralName].map((c: any) => Object.assign(this.newInstance(), c));
            this.nextPageToken = json.next_page_token;
            this.append(records);
            this.callback && this.callback(records);
        });
    }
}
